import { Col, DatePicker, Form, Input, Modal, Radio, Row, Select, Tabs, Typography } from 'antd'
import React, { useEffect, useMemo, useState } from 'react'
import { Button } from 'antd'
import { usePromiseTracker } from 'react-promise-tracker'
import { useCNDNStore } from '../../stores/CNDNStore'
import { dropDownMapping, isNotEmptyObject, sortBy } from '../../utils/app-common'
import { convertMillisToDateMoment } from '../../utils/luxon'
import SuspenseComponent from '../CommonComponent/SuspenseComponent'
import { OperationContext } from '../OperationComponent/Operation/OperationDetail'
import ManifestComponent from '../OperationComponent/Operation/OperationDetail/Manifest'

const { Title, Text } = Typography;

const CNDNRequestModal = ({ record }) => {

    const { setFieldsValue } = Form.useFormInstance()
    useEffect(() => {
        if (isNotEmptyObject(record?.at(0))) {
            for (const [key, value] of Object.entries(record.at(0))) {
                if (['cnRequest', 'waybillNo', 'cnWaybillNo', 'cnRequest', 'oracleInvoiceNumber', 'cndnRequestNo'].includes(key)) {
                    setFieldsValue({ [key]: value })
                }
                if (key === 'createdDate') setFieldsValue({ createdDate: convertMillisToDateMoment(value) })
                if (key === 'cnDate') setFieldsValue({ cnDate: convertMillisToDateMoment(value) })
            }
        }
    }, [record, setFieldsValue])
    return (
        <>
            <Row gutter={8}>
                <Col xxl={5} lg={4} md={6}>
                    <Form.Item name={'cnRequest'} label='Booking Code' labelCol={{ span: 24 }}>
                        <Input disabled />
                    </Form.Item>
                </Col>
                <Col xxl={5} lg={4} md={6}>
                    <Form.Item name='waybillNo' label='Waybill Number' labelCol={{ span: 24 }}>
                        <Input disabled />
                    </Form.Item>
                </Col> <Col xxl={5} lg={4} md={6}>
                    <Form.Item name='cnWaybillNo' label='CN/DN Waybill Number' labelCol={{ span: 24 }}>
                        <Input disabled />
                    </Form.Item>
                </Col>
                <Col xxl={5} lg={4} md={6}>
                    <Form.Item name={'createdDate'} label='Booking Date' labelCol={{ span: 24 }}>
                        <DatePicker disabled className='width_full'></DatePicker>
                    </Form.Item>
                </Col>
                <Col xxl={5} lg={4} md={6}>
                    <Form.Item name={'cndnRequestNo'} label='CN/DN No' labelCol={{ span: 24 }}>
                        <Input disabled />
                    </Form.Item>
                </Col>  <Col xxl={5} lg={4} md={6}>
                    <Form.Item name={'oracleInvoiceNumber'} label='Oracle Invoice Number' labelCol={{ span: 24 }}>
                        <Input disabled />
                    </Form.Item>
                </Col>
                {/* <Col xxl={4} lg={4} md={6}>
                    <Form.Item name={'cnDate'} label='CN Date' labelCol={{ span: 24 }}>
                        <DatePicker disabled className='width_full'></DatePicker>
                    </Form.Item>
                </Col> */}
            </Row>
            <Row gutter={5}>
                <Col xxl={8} md={8} lg={8}>
                    <Form.Item name={'remarks'} label='Remark' labelCol={{ span: 24 }}>
                        <Input.TextArea cols={15} rows={4}></Input.TextArea>
                    </Form.Item>
                </Col>
            </Row>
        </>

    )
}
const TabsComponent = ({ record }) => {

    const fromOperation = false;
    const selectedRow = record?.at(0);
    const [waybill, setWaybill] = useState(selectedRow?.waybillNo);
    const value = useMemo(() => ({
        ...selectedRow,
        waybillNo: waybill
        ,
        fromOperation
    }), [selectedRow, fromOperation, waybill]);

    const cnWaybillsMemo = useMemo(() => dropDownMapping(record, 'waybillNo', 'waybillNo'), [record]);

    const tabs = useMemo(() => {
        return [
            {
                id: '1',
                label: 'CN/DN Request',
                key: '1',
                children: <SuspenseComponent> <CNDNRequestModal record={record} /></SuspenseComponent>
            }, {
                id: '2',
                label: 'Manifest Detail',
                key: '2',
                children: <SuspenseComponent>
                    <OperationContext.Provider value={value}>
                        <Form>
                            <Col span={5}>
                                <Form.Item label="Select a waybill">
                                    <Select
                                        defaultValue={waybill}
                                        onChange={(value) => { setWaybill(value) }}
                                        showSearch
                                        filterOption={(input, option) =>
                                            (option!.children as unknown as string)
                                                ?.toLocaleLowerCase()
                                                ?.includes(input?.toLocaleLowerCase())
                                        }
                                    >
                                        {cnWaybillsMemo?.map((division) => (
                                            <React.Fragment key={division?.id}>
                                                <Select.Option value={division?.id}>
                                                    {division?.value}
                                                </Select.Option>
                                            </React.Fragment>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Form>
                        <Col span={5}>
                            <Title level={5} type='secondary'>Waybill Number: <Text mark>{waybill}</Text></Title>
                        </Col>
                        <ManifestComponent />
                    </OperationContext.Provider>
                </SuspenseComponent>
            },
        ]
    }, [value, record])

    return (
        <Tabs
            size={'middle'}
            type="line"
            destroyInactiveTabPane
            defaultActiveKey={'1'}
            items={tabs}
        />
    )
}
function ApprovalModalComponent({ isOpen, onCancel, record, title = '', approveOrRejectBy, onSubmit }:
    Readonly<{ record, isOpen: boolean, approveOrRejectBy: string, onCancel: (value: boolean) => void, title?: string, onSubmit: (values) => void }>) {
    const [form] = Form.useForm()
    const waybillsState = useCNDNStore(state => state?.waybills);
    const { waybills } = waybillsState || {};
    const { promiseInProgress: approvalArea } = usePromiseTracker({ area: 'approval-area' });

    const onApproveRejectHandler = (isApprove: boolean) => {
        onSubmit({
            cndnRequestIds: [waybills?.find(item => item?.childNode?.find(child => child?.id === record?.at(0).id))?.id ?? 0],
            [approveOrRejectBy]: isApprove,
            remarks: form.getFieldValue('remarks')
        })
    };

    const footerArray = [
        <Button key="back" onClick={() => onCancel(false)}>
            Cancel
        </Button>,
        <Button key="link" type="primary" danger onClick={() => onApproveRejectHandler(false)}>
            Reject
        </Button>,
        <Button key="submit" type="primary" onClick={() => onApproveRejectHandler(true)}>
            Approve
        </Button>,
    ];

    return (
        <Modal open={isOpen} onCancel={() => onCancel(false)} title={title} maskClosable={false} width={1500}
            onOk={() => onApproveRejectHandler(true)} centered confirmLoading={approvalArea} footer={footerArray}
        >
            <Form form={form} initialValues={{ remarks: '' }}>
                <TabsComponent record={record} />
            </Form>
        </Modal>
    )
}

export default ApprovalModalComponent